
// const API = "http://185.249.198.58:8083/api";
const API = "https://puzzle-meisterschaft.de/api";

export default API;